export default "__VITE_ASSET__D9gdTTFX__"